module.exports = __webpack_public_path__ + "static/media/icon2.08f9b21c.jpg";